module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/7-7a7db0eeae256f6746b40f83758c70ae.jpg";